module.exports = __webpack_public_path__ + "static/pinterest-1e3fc80c02ac7a30bac2f6e5e3277f55.png";